import { useSelector } from 'react-redux';
import { FUNCTIONALITY } from '../constants/types';

export interface PDFConfig {
  hospitalName: string;
  logoBlob: string;
  locale: string;
  address: string;
  city: string;
  email: string;
  phone: string;
}

export const usePDFConfig = () => {
  const currentInvestigation = useSelector((state: any) => state.investigations.currentInvestigation);
  
  if (!currentInvestigation) {
    return {
      config: null,
      loading: false,
      error: 'No billing information available'
    };
  }

  if (!currentInvestigation.billingInfo) {
    // SKIN-643: the billing header is required only where billing exists — the same
    // per-investigation gate as the /billing routes. An investigation without the
    // BILLING functionality (every SkincAIr study) prints with its own name alone.
    if (currentInvestigation.functionalities?.includes(FUNCTIONALITY.BILLING)) {
      return {
        config: null,
        loading: false,
        error: 'No billing information available'
      };
    }
    const config: PDFConfig = {
      hospitalName: currentInvestigation.name || '',
      logoBlob: '',
      locale: 'en',
      address: '',
      city: '',
      email: '',
      phone: ''
    };
    return {
      config,
      loading: false,
      error: null
    };
  }
  
  const billingInfo = currentInvestigation.billingInfo;
  const config: PDFConfig = {
    hospitalName: currentInvestigation.name || billingInfo.hospitalName,
    logoBlob: billingInfo.logoBlob,
    locale: billingInfo.locale || 'en',
    address: billingInfo.address,
    city: billingInfo.city,
    email: billingInfo.email,
    phone: billingInfo.phone
  };
  
  return {
    config,
    loading: false,
    error: null
  };
}; 